import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { menuItemFilter } from 'src/app/features/reports/models/wastedMenuItems';
import { WastedMenuItemService } from 'src/app/features/reports/services/wastedMenuItems.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { Patterns } from 'src/app/helpers/patterns';
import { Lookup } from 'src/app/models/Lookup';
import Swal from 'sweetalert2';

export interface DialogData {
  restaurantId: any,
  orderId: any,
  KitchenId: number,
  isOrder: boolean
}

@Component({
  selector: 'app-wasted-menu-item-form',
  templateUrl: './wasted-menu-item-form.component.html'
})
export class WastedMenuItemFormComponent extends DirtyComponent implements OnInit {

  loading = false;
  dataLoading = false;
  itemsLoading = true;
  isSubmitted = false;

  isOrder = false;
  isReportedOrder = false;
  orderLoading = true;
  ordersList: any[] = []
  orderItems: any[] = []
  selectedQuantity: number = 1;
  orderItemsLoading = false;

  sectionLoading = false;
  sectionSelected: any[] = [];
  searchText?: any;
  noSpecialTxt = Patterns.noSpecialTxt;
  sections: any[] = []
  items: any = []
  SelecteditemSizes: any[] = []

  lossReason: Lookup[] = []
  lossReasonLoading = true;
  disposition: Lookup[] = []
  dispositionLoading = true;
  NotAvailable = ''
  IsAvailable = ''

  pageSize = 5;
  pageNumber = 0;
  pageCount: number = 0;
  selector: string = '.menu-items';
  itemsList: any[] = []


  constructor(override dialogRef: MatDialogRef<WastedMenuItemFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    translate: TranslateService,
    private _formBuilder: FormBuilder,
    private service: WastedMenuItemService) {
    super(translate);
  }

  ngOnInit(): void {
    this.NotAvailable = this.translate.instant('wastedFood.Not Available');
    this.IsAvailable = this.translate.instant('wastedFood.Is Available');

    this.buildForm();
    // If it's Opens from KDS Screen
    if (this.data.orderId) {
      this.isReportedOrder = true
      this.formGroup.controls['orderId'].setValue(this.data.orderId)
    }
    this.getLossReasons();
    this.getDisposition();

    // Is this Item within an order? Toggle Off
    if (!this.isOrder && !this.isReportedOrder) {
      this.getSections();
      this.getMenuItems(true);
    } else {
      this.onOrderChange(this.data.orderId)
      if (!this.data.isOrder) {
        this.getOrdersList()
      }
    }

  }

  buildForm() {
    this.formGroup = this._formBuilder.group({
      orderId: [],
      itemSizesId: [],
      menuItemReservationId: [],
      restaurantId: [this.data.restaurantId],
      menuItemId: [null, [
        Validators.required
      ]],
      quantity: [],
      lossReasonId: [null, [
        Validators.required
      ]],
      dispositionLookupId: [null, [
        Validators.required
      ]],
      note: [null, [
        Validators.maxLength(100)
      ]]
    });
  }


  hasError(formGroup: FormGroup, controlName: string, errorName: string) {
    return formGroup.controls[controlName].hasError(errorName);
  }

  override canDeactivate() {
    return this.searchText || this.sectionSelected.length || this.formGroup.dirty;
  }


  hideOption(item: any) {
    return new RegExp(this.searchText, 'i').test(item.itemName) === false
  }
  // hideBySection(item: any) {
  //   return this.sectionSelected ? item.sectionId != this.sectionSelected : false
  // }
  isAllHidden() {
    return this.itemsList.every((item: any) => this.hideOption(item)) || !this.itemsList.length;
  }

  getOrdersList() {
    // Is this Item within an order? Toggle Off
    if (!this.isOrder) {
      this.orderLoading = true;
      this.service.getWasteItemsOrderList(this.data.restaurantId).subscribe((data: any) => {
        this.orderLoading = false;
        this.ordersList = data
        if (this.data.orderId) {
          this.isReportedOrder = true
        }
      })
      this.formGroup.controls['menuItemId'].reset();
    }
  }

  onOrderChange(value: any) {
    this.formGroup.controls['menuItemId'].reset();
    this.formGroup.controls['itemSizesId'].reset();

    if (value) {
      this.orderItemsLoading = true;
      this.service.getWasteOrderItems(value, this.data?.KitchenId).subscribe((data: any) => {
        this.orderItemsLoading = false
        this.orderItems = data;
      })
    }
  }

  counter(i: number) { return new Array(i + 1); }

  getSections() {
    this.sectionLoading = true;
    this.service.getMenuSectionsList(this.data.restaurantId).subscribe((data: any) => {
      this.sections = data;
      this.sectionLoading = false;
    })
  }

  getMenuItems(update = true) {
    if (update) {
      this.pageNumber = 0;
      this.itemsList = [];
    }
    this.itemsLoading = true
    const filter = new menuItemFilter()
    filter.restaurantId = this.data.restaurantId
    filter.pageSize = this.pageSize;
    filter.pageNumber = this.pageNumber;
    // if (!this.sectionSelected) {
    //   filter.sectionId = 0
    // } else {
    //   filter.sectionId = this.sectionSelected
    // }
    filter.sectionIds = this.sectionSelected
    if (this.searchText) {
      filter.itemName = this.searchText

    } else {
      this.searchText = ''
    }
    this.service.getMenuItemForWaste(filter).subscribe((data: any) => {
      this.items = data;
      if (this.items.pageData) {
        this.pageCount = Math.ceil(this.items.totalCount / this.pageSize);
        this.itemsList = this.itemsList.concat(this.items.pageData);
      }
      this.itemsLoading = false
    }, err => {
      this.itemsLoading = false;
      console.error(err);
    })
  }

  getNextPage() {
    if (this.pageNumber < this.pageCount - 1) {
      this.pageNumber += 1;
      this.getMenuItems(false);
    }
  }

  getSelecteditemSizes() {
    this.SelecteditemSizes = this.itemsList.find((item: any) => item.id == this.formGroup.controls['menuItemId'].value)?.itemSizes;
  }


  getLossReasons() {
    this.lossReasonLoading = true;
    this.service.getWasteItemsReasonList().subscribe((data: any) => {
      this.lossReasonLoading = false;
      this.lossReason = data;
    })
  }

  getDisposition() {
    this.dispositionLoading = true;
    this.service.getDispositionsList().subscribe((data: any) => {
      this.dispositionLoading = false;
      this.disposition = data;
    })
  }

  saveRecord() {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.loading = true;
      this.formGroup.controls['quantity'].setValue(1)
      let data;

      if (this.isOrder || this.isReportedOrder) {
        let orderItem = this.orderItems.find((item => item.id == this.formGroup.controls['menuItemId'].value));
        data = {
          orderId: this.formGroup.controls['orderId'].value,
          restaurantId: this.data.restaurantId,
          menuItemReservationId: orderItem?.id,
          quantity: orderItem?.isWeight ? orderItem.quantity : orderItem.selectedQuantity,
          lossReasonId: this.formGroup.controls['lossReasonId'].value,
          dispositionLookupId: this.formGroup.controls['dispositionLookupId'].value,
          note: this.formGroup.controls['note'].value
        }
      } else {
        data = {
          itemSizesId: this.formGroup.controls['itemSizesId'].value,
          restaurantId: this.data.restaurantId,
          lossReasonId: this.formGroup.controls['lossReasonId'].value,
          dispositionLookupId: this.formGroup.controls['dispositionLookupId'].value,
          note: this.formGroup.controls['note'].value
        }
      }
      this.service.newWasteMenuItems(data).subscribe((result) => {
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.translate.instant('swalMsg.savedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true);
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        }).then((res) => {
          if (error.status == 400) {
            this.dialogRef.close(true);
          }
        })
      });

    }
  }

}
